import React from 'react';
import addBannerMessages from 'app/blocks/banner-messages/banner-messages';

export default function withBanner<P>(Component: React.ComponentType<P>): React.ComponentType<P> {
    return function WithBanner(props) {
        const path = `${window.location.pathname}${window.location.search}`.replace(/^\/*index.html\/*/, '');
        React.useEffect(() => {
            addBannerMessages({
                appendTo: 'banner-messages-container',
                bannerMessageAllSpaElemId: 'AS__info-message-all-spa',
                bannerMessageElemId: 'AS__info-message',
                path,
                pathPartsWithMessages: [
                    { 'type=online-open': 'banner-message-online-open' },
                    { 'type=openaccess': 'banner-message-openaccess' },
                ],
                pathsWithMessages: ['login', 'register', 'profile', 'dashboard', 'orders'],
            });
        }, [path]);

        return <Component {...props} />;
    };
}
